import {AuwCookieBanner} from "./AuwCookieBanner";

export class AuwResetCookieChoice extends AuwCookieBanner{

    constructor($el){
        super($el);
    }

    __WindowLoad() {
        //die muss hier sein, damit die windowload des banners nicht ausgeführt wird
    }

    __PageReady(){
        this.$el.on("click",this.resetCookieChoice.bind(this))
    }

    resetCookieChoice(e){
        e.preventDefault();
        this.eraseCookie(this.config.cookieName);
        window.location.reload();
    }
}
